"use client"

import {ModalProvider} from "@/components/DownloaderApp/Modal";
import {DownloaderApp} from "@/components/DownloaderApp/DownloaderApp";
import {NetworkProvider} from "@/components/DownloaderApp/Network";
import {PremiumProvider} from "@/components/DownloaderApp/usePremium";
import {
    QueryClientProvider,
} from '@tanstack/react-query'
import {queryClient} from "@/components/DownloaderApp/queryClient";
import type {DownloaderAppProps} from "./types";

export default function App(props: DownloaderAppProps){
    return <QueryClientProvider client={queryClient}><ModalProvider><PremiumProvider>
        <NetworkProvider>
        <DownloaderApp {...props} />
            </NetworkProvider>
    </PremiumProvider></ModalProvider></QueryClientProvider>
}